/* import __COLOCATED_TEMPLATE__ from './multiple-from-elsewhere.hbs'; */
import FromElsewhereComponent from './from-elsewhere';
export default class extends FromElsewhereComponent {}